function OnSuccessGravure(response) {
    if ($(response).attr('id') == 'gravure-edit-form') {
        $('.personnalisation-form-wrapper').html(response);
        $('#preloader').fadeOut();
    }
    else {
        // Tracking via TagCo
        if (response.PopinConfirmationUrl != undefined) {
            $("#preloader").fadeOut();
            $('#engraving-preview-modal').html(response.PopinRender);
            $('#engraving-preview-modal').foundation('reveal', 'open');
            $('#ajax-modal-small').foundation('reveal', 'open', {
                url: response.PopinConfirmationUrl
            });
           
        }
        else {
            window.location = response.Redirection;
        }
    }
}

function OnShareByEmailSuccess(result) {
    var popinWrapper = $('#ajax-modal-small');
    popinWrapper.html(result);
}

function OnShareByEmailFailure(result) {
    var popinWrapper = $('#ajax-modal-small');
    popinWrapper.html(result);
}

function BeforeUpdateInlineGravureForm(response) { 
    $("#preloader").show();
}

function DisableButton() {
    $("#retrait-bijouterie-wrapper button").attr("disabled", "disabled");
}

function EnableButton() {
    $("#retrait-bijouterie-wrapper button").removeAttr("disabled");
}

// Mise à jour formulaire ClickNCollect
function OnSuccessCNCAvailability(response) {
    $("#retrait-bijouterie-wrapper").html(response);

    EnableButton();

    Foundation.libs.common.hidePreloader();
}

function OnFailureCNCAvailability(response) {
    // On réactive les boutons
    EnableButton();
}

// Mise à jour formulaire ClickNCollect
function OnSuccessCNCBook(response) {
    $("#retrait-bijouterie-wrapper").html(response);

    EnableButton();

    Foundation.libs.common.hidePreloader()
}

function OnFailureCNCBook(response) {
    Foundation.libs.common.hidePreloader()
    // On réactive les boutons
    EnableButton();
}